import React from 'react';
import './Accounts.css'


const Accounts = (props) => {
  return (
    <div className="serviceInfo">
      <span className="serviceInfoContainer">
        <h3 className="serviceTitle">For Service Use Only</h3>
      </span>
    </div>
  );
};

export default Accounts;
